import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Button,
  Input,
  FormGroup,
  Label,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import axios from "axios";
import { API_MAI_FALI } from "../utils";
import { logoutUser } from "../actions/AuthAction";

const DataOrmas = (props) => {
  const [ormasList, setOrmasList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOrmas, setSelectedOrmas] = useState(null);
  const [detailModal, setDetailModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [formData, setFormData] = useState({
    nama_organisasi: "",
    email_organisasi: "",
    alamat_sekretariat: "",
    bentuk_organisasi: "",
    jenis_organisasi: "",
  });
  const [submitLoading, setSubmitLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      fetchOrmasList();
    } else {
      logoutUser(props.history);
    }
  }, [props.history, currentPage, searchTerm]);

  const fetchOrmasList = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_MAI_FALI}ormas`);
      if (response.data.success) {
        setOrmasList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching ORMAS list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleViewDetail = async (ormasId) => {
    try {
      const response = await axios.get(`${API_MAI_FALI}ormas/${ormasId}`);
      if (response.data.success) {
        setSelectedOrmas(response.data.data);
        setDetailModal(true);
      }
    } catch (error) {
      console.error("Error fetching ORMAS detail:", error);
    }
  };

  const getBentukOrganisasiLabel = (bentuk) => {
    switch (bentuk) {
      case "Berbadan Hukum":
        return "Berbadan Hukum";
      case "Tidak Berbadan Hukum":
        return "Tidak Berbadan Hukum";
      default:
        return bentuk;
    }
  };

  const getJenisOrganisasiLabel = (jenis) => {
    switch (jenis) {
      case "Yayasan":
        return "Yayasan";
      case "Perkumpulan":
        return "Perkumpulan";
      case "Forum":
        return "Forum";
      case "Lembaga":
        return "Lembaga";
      case "Lainnya":
        return "Lainnya";
      default:
        return jenis;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    setError("");

    // Validate required fields
    const requiredFields = [
      "nama_organisasi",
      "email_organisasi",
      "alamat_sekretariat",
      "bentuk_organisasi",
      "jenis_organisasi",
    ];
    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      setError(
        `Mohon lengkapi field yang wajib diisi: ${missingFields.join(", ")}`
      );
      setSubmitLoading(false);
      return;
    }

    try {
      console.log("Submitting data:", formData);

      const response = await axios.post(`${API_MAI_FALI}ormas`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 10000, // 10 second timeout
      });

      console.log("Response:", response.data);

      if (response.data.success) {
        setSuccess(true);
        setFormData({
          nama_organisasi: "",
          email_organisasi: "",
          alamat_sekretariat: "",
          bentuk_organisasi: "",
          jenis_organisasi: "",
        });
        setAddModal(false);
        fetchOrmasList(); // Refresh the list
      }
    } catch (error) {
      console.error("Error details:", error);

      if (error.response) {
        // Server responded with error status
        setError(
          `Error ${error.response.status}: ${
            error.response.data?.message || error.response.statusText
          }`
        );
      } else if (error.request) {
        // Request was made but no response received
        setError(
          "Tidak dapat terhubung ke server. Pastikan backend berjalan di port 5000."
        );
      } else {
        // Something else happened
        setError("Terjadi kesalahan saat menyimpan data. Silakan coba lagi.");
      }
    } finally {
      setSubmitLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      nama_organisasi: "",
      email_organisasi: "",
      alamat_sekretariat: "",
      bentuk_organisasi: "",
      jenis_organisasi: "",
    });
    setError("");
    setSuccess(false);
  };

  const bentukOrganisasiOptions = [
    { value: "Berbadan Hukum", label: "Berbadan Hukum" },
    { value: "Tidak Berbadan Hukum", label: "Tidak Berbadan Hukum" },
  ];

  const jenisOrganisasiOptions = [
    { value: "Yayasan", label: "Yayasan" },
    { value: "Perkumpulan", label: "Perkumpulan" },
    { value: "Forum", label: "Forum" },
    { value: "Lembaga", label: "Lembaga" },
    { value: "Lainnya", label: "Lainnya" },
  ];

  // Filter data based on search term
  const filteredOrmasList = ormasList.filter(
    (ormas) =>
      ormas.nama?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ormas.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ormas.alamat_sekretariat?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Paginate data
  const paginatedOrmasList = filteredOrmasList.slice(
    (currentPage - 1) * 10,
    currentPage * 10
  );

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  <i className="tim-icons icon-bank text-primary" />
                  Data ORMAS
                </CardTitle>
                <p className="text-muted">
                  Daftar Organisasi Kemasyarakatan yang telah terdaftar dalam
                  sistem SIO ESA
                </p>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label>Cari ORMAS</Label>
                      <Input
                        type="text"
                        placeholder="Cari berdasarkan nama organisasi..."
                        value={searchTerm}
                        onChange={handleSearch}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="text-right">
                    <Button
                      color="primary"
                      onClick={() => {
                        resetForm();
                        setAddModal(true);
                      }}
                    >
                      <i className="tim-icons icon-simple-add" />
                      Tambah ORMAS Baru
                    </Button>
                  </Col>
                </Row>

                {loading ? (
                  <div className="text-center">
                    <p>Memuat data...</p>
                  </div>
                ) : (
                  <>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Nama Organisasi</th>
                          <th>Bentuk</th>
                          <th>Jenis</th>
                          <th>Tanggal Daftar</th>
                          <th>Aksi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedOrmasList.map((ormas, index) => (
                          <tr key={ormas.id}>
                            <td>{(currentPage - 1) * 10 + index + 1}</td>
                            <td>
                              <strong>{ormas.nama}</strong>
                              <br />
                              <small className="text-muted">
                                {ormas.email}
                              </small>
                            </td>
                            <td>
                              {getBentukOrganisasiLabel(
                                ormas.bentuk_organisasi
                              )}
                            </td>
                            <td>
                              {getJenisOrganisasiLabel(ormas.jenis_organisasi)}
                            </td>
                            <td>
                              {new Date(ormas.created_at).toLocaleDateString(
                                "id-ID"
                              )}
                            </td>
                            <td>
                              <Button
                                color="info"
                                size="sm"
                                onClick={() => handleViewDetail(ormas.id)}
                              >
                                <i className="tim-icons icon-zoom-split-in" />
                                Detail
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                    {filteredOrmasList.length === 0 && (
                      <Alert color="info">
                        Tidak ada data ORMAS yang ditemukan.
                      </Alert>
                    )}

                    {Math.ceil(filteredOrmasList.length / 10) > 1 && (
                      <Row>
                        <Col md="12" className="text-center">
                          <Pagination>
                            <PaginationItem disabled={currentPage === 1}>
                              <PaginationLink
                                onClick={() =>
                                  handlePageChange(currentPage - 1)
                                }
                              >
                                Sebelumnya
                              </PaginationLink>
                            </PaginationItem>

                            {Array.from(
                              {
                                length: Math.ceil(
                                  filteredOrmasList.length / 10
                                ),
                              },
                              (_, i) => i + 1
                            ).map((page) => (
                              <PaginationItem
                                key={page}
                                active={page === currentPage}
                              >
                                <PaginationLink
                                  onClick={() => handlePageChange(page)}
                                >
                                  {page}
                                </PaginationLink>
                              </PaginationItem>
                            ))}

                            <PaginationItem
                              disabled={
                                currentPage ===
                                Math.ceil(filteredOrmasList.length / 10)
                              }
                            >
                              <PaginationLink
                                onClick={() =>
                                  handlePageChange(currentPage + 1)
                                }
                              >
                                Selanjutnya
                              </PaginationLink>
                            </PaginationItem>
                          </Pagination>
                        </Col>
                      </Row>
                    )}
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal Tambah ORMAS */}
        <Modal
          isOpen={addModal}
          toggle={() => {
            setAddModal(false);
            resetForm();
          }}
          size="lg"
        >
          <ModalHeader
            toggle={() => {
              setAddModal(false);
              resetForm();
            }}
          >
            Tambah ORMAS Baru
          </ModalHeader>
          <ModalBody>
            {success && (
              <Alert color="success">Data ORMAS berhasil ditambahkan!</Alert>
            )}

            {error && <Alert color="danger">{error}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Nama Organisasi *</Label>
                    <Input
                      type="text"
                      name="nama_organisasi"
                      value={formData.nama_organisasi}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Email Organisasi *</Label>
                    <Input
                      type="email"
                      name="email_organisasi"
                      value={formData.email_organisasi}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup>
                <Label>Alamat Sekretariat *</Label>
                <Input
                  type="textarea"
                  name="alamat_sekretariat"
                  value={formData.alamat_sekretariat}
                  onChange={handleInputChange}
                  rows="3"
                  required
                />
              </FormGroup>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Bentuk Organisasi *</Label>
                    <Input
                      type="select"
                      name="bentuk_organisasi"
                      value={formData.bentuk_organisasi}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Pilih Bentuk Organisasi</option>
                      {bentukOrganisasiOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Jenis Organisasi *</Label>
                    <Input
                      type="select"
                      name="jenis_organisasi"
                      value={formData.jenis_organisasi}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Pilih Jenis Organisasi</option>
                      {jenisOrganisasiOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setAddModal(false);
                resetForm();
              }}
            >
              Batal
            </Button>
            <Button
              type="submit"
              color="primary"
              disabled={submitLoading}
              onClick={handleSubmit}
            >
              {submitLoading ? "Menyimpan..." : "Simpan ORMAS"}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Detail ORMAS */}
        <Modal
          isOpen={detailModal}
          toggle={() => setDetailModal(false)}
          size="lg"
        >
          <ModalHeader toggle={() => setDetailModal(false)}>
            Detail ORMAS: {selectedOrmas?.nama}
          </ModalHeader>
          <ModalBody>
            {selectedOrmas && (
              <Row>
                <Col md="6">
                  <h6>Informasi Organisasi</h6>
                  <Table borderless size="sm">
                    <tbody>
                      <tr>
                        <td>
                          <strong>Nama Organisasi:</strong>
                        </td>
                        <td>{selectedOrmas.nama}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Email:</strong>
                        </td>
                        <td>{selectedOrmas.email}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Bentuk Organisasi:</strong>
                        </td>
                        <td>
                          {getBentukOrganisasiLabel(
                            selectedOrmas.bentuk_organisasi
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Jenis Organisasi:</strong>
                        </td>
                        <td>
                          {getJenisOrganisasiLabel(
                            selectedOrmas.jenis_organisasi
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
                <Col md="6">
                  <h6>Alamat Sekretariat</h6>
                  <p>{selectedOrmas.alamat_sekretariat}</p>

                  <h6>Informasi Pendaftaran</h6>
                  <Table borderless size="sm">
                    <tbody>
                      <tr>
                        <td>
                          <strong>Tanggal Daftar:</strong>
                        </td>
                        <td>
                          {new Date(
                            selectedOrmas.created_at
                          ).toLocaleDateString("id-ID")}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Terakhir Update:</strong>
                        </td>
                        <td>
                          {new Date(
                            selectedOrmas.updated_at
                          ).toLocaleDateString("id-ID")}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setDetailModal(false)}>
              Tutup
            </Button>
            <Button
              color="primary"
              onClick={() => {
                setDetailModal(false);
                props.history.push(
                  `/pelaporan-kegiatan?ormas=${selectedOrmas?.id}`
                );
              }}
            >
              Laporkan Kegiatan
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default DataOrmas;
